import React, { useState } from 'react';
import DigitalSignage from './Tabs/DigitalSignage';
import ProjectorTv from './Tabs/ProjectorTv';
import VirtualHybridEvent from './Tabs/VirtualHybridEvent';
import { Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Sidebardata from "./SidebarLeft"
import SidebarModal from './Modals/ExploreContent'
import { shallowEqual, useSelector } from 'react-redux';
import SidebarRight from './Modals/Modal'
import $ from 'jquery'
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

const Display = () => {

    const { userData } = useSelector((state) => state.authenticated, shallowEqual);
    const {wallData} = useSelector((state) => state.wallData, shallowEqual);
    const themeData = useSelector(state => state.appsMore,shallowEqual);
    const virtualEvent = userData ? userData.user.virtualEvent : 0

    const [activeTab, setActiveTab] = useState(1);
    const [opentSidebar, setopentSidebar] = useState('open-sidebar')
    const [openExplorebar, setopenExplorebar] = useState('');

    window.$("#initPublishPopupId").click(function(){
        $(".display_modal_publish").show()
    })

    return (

        wallData ?
            <>
                <div className="display_modal display_modal_publish">
                    <Tabs className={'w-100'}>
                        <div className="d-flex align-items-center justify-content-between border-bottom page_custom_header" id="kt_subheader">
                            <div className="container-fluid p-0">
                                <div className="d-flex align-items-center justify-content-between flex-nowrap">
                                    <div className="d-flex align-items-center overflow-hidden">
                                        <Button variant='link' onClick={() => window.$(".display_modal_publish").hide()} className="border-0 border-end rounded-0 back_btn me-2" id="display_close" data-factors-form-bind="true" data-factors-click-bind="true">
                                            <FontAwesomeIcon type={'light'} icon={'angle-left'} iconClass={'fs-4'} />
                                        </Button>
                                        <div className="d-flex align-items-end tab_responsive__">

                                            <ul className="nav nav-tabs nav-tabs-space-lg flex-nowrap align-content-end nav-tabs-line nav-tabs-bold top_nav_tabs" role="tablist">
                                                <li className="nav-item">
                                                    <button onClick={() => setActiveTab(1)} type="button" className={`nav-link ${activeTab == 1 ? `active` : ''}`} data-bs-toggle="tab" data-bs-target="#projector-tv" data-factors-form-bind="true" data-factors-click-bind="true">
                                                        <span className="nav-text text-nowrap">Projector/TV</span>
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button onClick={() => setActiveTab(2)} type="button" className={`nav-link ${activeTab == 2 ? `active` : ''}`} data-bs-toggle="tab" data-bs-target="#digital-signage" data-factors-form-bind="true" data-factors-click-bind="true">
                                                        <span className="nav-text text-nowrap">Digital Signage</span>
                                                    </button>
                                                </li>

                                                {virtualEvent ?
                                                    <li className="nav-item">
                                                        <button onClick={() => setActiveTab(3)} type="button" className={`nav-link ${activeTab == 3 ? `active` : ''}`} data-bs-toggle="tab" data-bs-target="#virtual-event" data-factors-form-bind="true" data-factors-click-bind="true">
                                                            <span className="nav-text text-nowrap">Virtual / Hybrid Events</span>
                                                        </button>
                                                    </li> : null }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end close_btn">
                                        <Button variant='link' onClick={() => window.$(".display_modal_publish").hide()} className="border-0 border-start ms-2 rounded-0 back_btn" data-factors-form-bind="true" data-factors-click-bind="true">
                                            <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={''} />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="d-flex flex-column-fluid publish_wrap">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="screen_wrapper">
                                            <div className="tab-content py-5">
                                                <div className={`tab-pane fade ${activeTab == 1 ? 'active show ' : ''} item-fadeIn`} id={`projector-tv`} role="tabpanel" aria-labelledby="projector-tv-tab">
                                                    <div className={`publish_wrapper ${opentSidebar}  ${openExplorebar}`}>
                                                        <div className="publish_overlay aside-overlay" />
                                                        <ProjectorTv themeData={themeData} wallData={wallData} opentSidebar={opentSidebar} setopentSidebar={setopentSidebar} sideBarMenu={Sidebardata()} />
                                                        <SidebarRight page={activeTab} openExplorebar={openExplorebar} setopenExplorebar={setopenExplorebar} />
                                                    </div>
                                                </div>


                                                <div className={`tab-pane fade  ${activeTab == 2 ? 'active show ' : ''} item-fadeIn`} id={`digital-signage`} role="tabpanel" aria-labelledby="projector-tv-tab">
                                                    <div className={`publish_wrapper ${opentSidebar}  ${openExplorebar}`}>
                                                        <div className="publish_overlay aside-overlay" />
                                                        <DigitalSignage themeData={themeData} wallData={wallData} opentSidebar={opentSidebar} setopentSidebar={setopentSidebar} sideBarMenu={Sidebardata()} />
                                                        <SidebarRight page={activeTab} openExplorebar={openExplorebar} setopenExplorebar={setopenExplorebar} />
                                                    </div>
                                                </div>


                                                <div className={`tab-pane  ${activeTab == 3 ? 'active show ' : ''} show item-fadeIn`} id={`virtual-event`} role="tabpanel" aria-labelledby="projector-tv-tab">
                                                    <div className={`publish_wrapper ${opentSidebar}  ${openExplorebar}`}>
                                                        <div className="publish_overlay aside-overlay" />
                                                        <VirtualHybridEvent  themeData={themeData} wallData={wallData} opentSidebar={opentSidebar} setopentSidebar={setopentSidebar} sideBarMenu={Sidebardata()} />
                                                        <SidebarRight page={activeTab} openExplorebar={openExplorebar} setopenExplorebar={setopenExplorebar} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tabs>
                </div>
                <SidebarModal wallData={wallData}/>
            </> : null
    )
}

export default Display